module.exports = __webpack_public_path__ + "static/media/handler1.bf8e3d52.png";